const activeJobsByPrinter = new Map();

export function resetJobLiveInProgress() {
    activeJobsByPrinter.clear();
}

export function seedJobLiveInProgress(jobs) {
    activeJobsByPrinter.clear();
    (jobs || []).forEach((job) => {
        if (job.status !== 'em_andamento' || !job.printer_uuid) {
            return;
        }
        const jobId = job.id || job.uuid;
        if (!jobId) {
            return;
        }
        if (!activeJobsByPrinter.has(job.printer_uuid)) {
            activeJobsByPrinter.set(job.printer_uuid, new Set());
        }
        activeJobsByPrinter.get(job.printer_uuid).add(jobId);
    });
}

export function applyJobLiveNotification(detail) {
    if (!detail?.printerUuid || !detail?.jobUuid) {
        return;
    }

    if (!activeJobsByPrinter.has(detail.printerUuid)) {
        activeJobsByPrinter.set(detail.printerUuid, new Set());
    }

    const printerJobs = activeJobsByPrinter.get(detail.printerUuid);
    if (detail.action === 'started') {
        printerJobs.add(detail.jobUuid);
    } else if (detail.action === 'finished') {
        printerJobs.delete(detail.jobUuid);
    }
}

export function isPrinterLivePrinting(printerUuid) {
    return (activeJobsByPrinter.get(printerUuid)?.size ?? 0) > 0;
}

export function buildLivePrintingSet(printerUuids = []) {
    const printing = new Set();
    printerUuids.forEach((printerUuid) => {
        if (isPrinterLivePrinting(printerUuid)) {
            printing.add(printerUuid);
        }
    });
    return printing;
}
